import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#0842A0] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/968c370221603733d312598be0660945/76f1e59cb0ede40759a88b475c1da3a0.png" 
              alt="COP Mansfield Logo" 
              className="h-16 w-auto mb-4"
              style={{ mixBlendMode: 'screen' }}
            />
            <p className="text-sm text-white/80 leading-relaxed">
              A vibrant multicultural church community serving God and humanity in Mansfield.
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Ministries</h4>
            <ul className="space-y-2">
              <li>
                <a onClick={() => scrollToSection('ministries')} className="text-sm text-white/80 hover:text-[#FFD700] transition-colors cursor-pointer">
                  Men Ministry
                </a>
              </li>
              <li>
                <a onClick={() => scrollToSection('ministries')} className="text-sm text-white/80 hover:text-[#FFD700] transition-colors cursor-pointer">
                  Women Ministry
                </a>
              </li>
              <li>
                <a onClick={() => scrollToSection('ministries')} className="text-sm text-white/80 hover:text-[#FFD700] transition-colors cursor-pointer">
                  Youth Ministry
                </a>
              </li>
              <li>
                <a onClick={() => scrollToSection('ministries')} className="text-sm text-white/80 hover:text-[#FFD700] transition-colors cursor-pointer">
                  Children Ministry
                </a>
              </li>
              <li>
                <a onClick={() => scrollToSection('ministries')} className="text-sm text-white/80 hover:text-[#FFD700] transition-colors cursor-pointer">
                  Evangelism Ministry
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>Quick Links</h3>
            <ul className="space-y-3">
              <li><a href="#home" className="hover:text-[#FFD700] transition-colors text-sm">Home</a></li>
              <li><a href="#about" className="hover:text-[#FFD700] transition-colors text-sm">About Us</a></li>
              <li>
                <button 
                  onClick={() => navigate('/beliefs')}
                  className="hover:text-[#FFD700] transition-colors text-sm cursor-pointer bg-transparent border-none text-white text-left p-0"
                >
                  Our Beliefs
                </button>
              </li>
              <li><a href="#ministries" className="hover:text-[#FFD700] transition-colors text-sm">Our Ministries</a></li>
              <li>
                <button 
                  onClick={() => navigate('/events')}
                  className="hover:text-[#FFD700] transition-colors text-sm cursor-pointer bg-transparent border-none text-white text-left p-0"
                >
                  Events
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/resources')}
                  className="hover:text-[#FFD700] transition-colors text-sm cursor-pointer bg-transparent border-none text-white text-left p-0"
                >
                  Resources
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-sm text-white/80">
                <i className="ri-map-pin-line mr-2 mt-1 text-[#FFD700]"></i>
                <span>Mansfield, Nottinghamshire, UK</span>
              </li>
              <li className="flex items-center text-sm text-white/80">
                <i className="ri-phone-line mr-2 text-[#FFD700]"></i>
                <a href="tel:+447718134887" className="hover:text-[#FFD700] transition-colors">
                  (+44) 7718134887
                </a>
              </li>
              <li className="flex items-center text-sm text-white/80">
                <i className="ri-mail-line mr-2 text-[#FFD700]"></i>
                <a href="mailto:info@mansfieldpiwc.com" className="hover:text-[#FFD700] transition-colors">
                  info@mansfieldpiwc.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-white/70 mb-4 md:mb-0">
              © 2025 Church of Pentecost UK Mansfield. All rights reserved.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/70 hover:text-[#FFD700] transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
